import * as React from 'react';
import '../../css/TestView.scss';

const XPOINT_DIST = 150;
const XPOINT_DISP = 50;
const YRANGE_PERCENT = 0.1;

export default class CustomChart extends React.Component<any, any> {
    canvas: any;
    canvasDiv: any;
    canvasLabel: any;
    canvasToolTip: any;
    labelPos: any;
    dataPointsPos: any;

    constructor(props: any) {
        super(props);
        this.labelPos = [];
    }

    componentDidMount() {
        this.componentDidUpdate();
    }

    componentDidUpdate() {
        this.canvas.width = (this.props.data.length + 1) * XPOINT_DIST > this.props.width ?  
                            (this.props.data.length + 1) * XPOINT_DIST : this.props.width ;
        this.createGradient(this.canvas); 
        this.drawYRangeLines(this.canvas);
        this.drawBaseLine(this.canvas); 
 
        this.createGradient(this.canvasLabel); 
        this.drawYRangeLines(this.canvasLabel);
        this.drawBaseLine(this.canvasLabel); 
        this.drawYRangeLabels(this.canvasLabel);
  
        this.drawXLabels(this.canvas); 
        this.plotPoints(this.canvas);
        let obj = this;  
        this.canvasLabel.addEventListener('mousemove', (evt: any) => {
            let mousePos = obj.getMousePos(obj.canvasLabel, evt);
            console.log(mousePos);
            let idx = 0;
            let found = false;
            obj.labelPos.forEach( (lablePos: any) => {
                if (obj.isBetween(mousePos, lablePos)) {
                    found = true;
                    obj.createYLabelToolTip(mousePos, idx);
                }
                idx++;
            });
            if ( !found ) {
                obj.canvasToolTip.width = 0;
                obj.canvasToolTip.height = 0;
            }
        });
        
        this.canvas.addEventListener('mousemove', (evt: any) => {
            let mousePos = obj.getMousePos(obj.canvas, evt);
//            console.log(mousePos);
            let idx = 0;
            let found = false;
            obj.dataPointsPos.forEach( (dataPos: any) => {
                if (obj.isBetween(mousePos, dataPos)) {
                    found = true;
                    console.log('found');
                    obj.createDataLabelToolTip(mousePos, idx);
                }
                idx++;
            });

            if ( !found ) {
                obj.canvasToolTip.width = 0;
                obj.canvasToolTip.height = 0;
            }
        });
    }

    render() {
        return (
            <div className="TestView">
            <table cellSpacing={0} cellPadding={0}>
                <tr>
                    <td style={{ width: XPOINT_DIST - 50, verticalAlign: 'top' }}>
                        <canvas 
                            ref={e => { this.canvasLabel = e; }} 
                            height={this.props.height} 
                            width={XPOINT_DIST - 50} 
                        />
                    </td>
                    <td>
                        <div 
                            ref={e => { this.canvasDiv = e; }}
                            style={{ width: this.props.width, overflowX: 'auto'}} 
                        >
                            <canvas ref={e => { this.canvas = e; }} height={this.props.height} />
                        </div>
                        <canvas 
                                ref={e => { this.canvasToolTip = e; }} 
                                height={0} 
                                width={0} 
                                style={{ position: 'absolute' }}
                        />
                    </td>
                </tr>
            </table>
            </div>
        );
    }

    private createDataLabelToolTip(mousePos: any, idx: any) {
        this.canvasToolTip.width = 250;
        this.canvasToolTip.height = 50;
        
        this.canvasToolTip.style.top = (mousePos.oy + 20 + window.scrollY) + 'px';
        let ctx = this.canvasToolTip.getContext('2d');
        ctx.font = 'bold 12px Arial';
        let str = this.props.datalabels[idx].split('\n');
        let width = 0;
        str.forEach( (s: any) => {
            width = width > ctx.measureText(s).width ? width 
                    : ctx.measureText(s).width;
        });
        let leftPosAdjust = this.canvasDiv.getBoundingClientRect().left + this.props.width - width  > mousePos.ox ?
                            width / 2 : width;
        this.canvasToolTip.style.left = (mousePos.ox - leftPosAdjust + window.scrollX ) + 'px';
        this.canvasToolTip.width = width + 18;
        ctx.clearRect(ctx, 0, 0, this.canvasToolTip.width, this.canvasToolTip.height);
        ctx.font = 'bold 12px Arial';
        ctx.fillStyle = '#eeeeee';
        this.roundRect(ctx, 0, 0, this.canvasToolTip.width, this.canvasToolTip.height, 5, '#eeeeee', null);
        ctx.fillStyle = '#222222';
        let ypos = 20;
        str.forEach( (s: any) => {                    
            ctx.fillText( s , 8, ypos);
            ctx.fillStyle = '#555555';
            ypos = ypos + 15;
        });
    }

    private createYLabelToolTip(mousePos: any, idx: any) {
        this.canvasToolTip.width = 250;
        this.canvasToolTip.height = 30;
        this.canvasToolTip.style.left = (mousePos.ox + 10 + + window.scrollX) + 'px';
        this.canvasToolTip.style.top = (mousePos.oy + 20 + window.scrollY) + 'px';
        let ctx = this.canvasToolTip.getContext('2d');
        ctx.font = 'bold 12px Arial';
        let width = ctx.measureText(this.props.yLabelText[idx]).width;
        this.canvasToolTip.width = width + 18;
        ctx.clearRect(ctx, 0, 0, this.canvasToolTip.width, this.canvasToolTip.height);
        ctx.font = 'bold 12px Arial';
        ctx.fillStyle = '#eeeeee';
        this.roundRect(ctx, 0, 0, this.canvasToolTip.width, this.canvasToolTip.height, 5, '#eeeeee', null);
        ctx.fillStyle = '#222222';                    
        ctx.fillText( this.props.yLabelText[idx] , 8, 18);
    }

    private roundRect(ctx: any, x: any, y: any, width: any, height: any, radius: any, fill: any, stroke: any) {
        
        if (typeof stroke === 'undefined') {
          stroke = true;
        }
        
        if (typeof radius === 'undefined') {
          radius = 5;
        }
        
        if (typeof radius === 'number') {
          radius = {tl: radius, tr: radius, br: radius, bl: radius};
        } else {
          radius = {tl: 0, tr: 0, br: 0, bl: 0};
        }

        ctx.beginPath();
        ctx.moveTo(x + radius.tl, y);
        ctx.lineTo(x + width - radius.tr, y);
        ctx.quadraticCurveTo(x + width, y, x + width, y + radius.tr);
        ctx.lineTo(x + width, y + height - radius.br);
        ctx.quadraticCurveTo(x + width, y + height, x + width - radius.br, y + height);
        ctx.lineTo(x + radius.bl, y + height);
        ctx.quadraticCurveTo(x, y + height, x, y + height - radius.bl);
        ctx.lineTo(x, y + radius.tl);
        ctx.quadraticCurveTo(x, y, x + radius.tl, y);
        ctx.closePath();
        if (fill) {
          ctx.fill();
        }
        if (stroke) {
          ctx.stroke();
        }      
      }

    private isBetween(mousePos: any, rect: any) {
        return mousePos.x >= rect.p1.x && mousePos.x <= rect.p2.x && mousePos.y >= rect.p1.y && mousePos.y <= rect.p2.y;
    }

    private getMousePos(canvas: any, evt: any) {
        var rect = canvas.getBoundingClientRect();
        return {
          x: evt.clientX - rect.left,
          y: evt.clientY - rect.top,
          ox: evt.clientX,
          oy: evt.clientY
        };
    }

    private drawYRangeLabels(canvas: any) {
        const ctx = canvas.getContext('2d');
        let cnt = 0;
        ctx.fillStyle = '#333333';
        ctx.font = 'Bold 24px Arial Black';
        this.labelPos = [];
        this.props.yRangelabels.forEach( (label: any) => {
            let xpos = 10;
            let ypos = cnt * (this.props.height * YRANGE_PERCENT) + ((this.props.height * YRANGE_PERCENT) / 2 ) + 10 ;
            let textw = ctx.measureText(label).width;
            ctx.fillText( label , xpos, ypos );
            this.labelPos.push( { p1: { x: xpos, y: ypos - 30 }, p2: { x: xpos +  textw , y: ypos } } );
            cnt = cnt +  1;
        });
    }

    private drawYRangeLines(canvas: any) {
        const ctx = canvas.getContext('2d');
        ctx.fillStyle = '#000000';
        for ( let i = 1; i < this.props.yRangelabels.length; i++ ) {
            let xpos = 0;
            let ypos = i * (this.props.height * YRANGE_PERCENT) ;
            ctx.fillRect( xpos, ypos, canvas.width, 2); 
        }        
    }

    private drawXLabels(canvas: any) {
        const ctx = canvas.getContext('2d');
        const LINE_HEIGHT = 14;
        let cnt = 0;
        ctx.fillStyle = '#eeeeee';
        ctx.font = `Bold ${LINE_HEIGHT}px Arial Black`;

        this.props.xLabels.forEach( (label: any) => {
            let xpos = XPOINT_DISP + cnt * XPOINT_DIST;
            let ypos = canvas.height * ( 1 - YRANGE_PERCENT ) + 30 ;
            let xlabelparts = label.split('\n');
            xlabelparts.forEach( (part: any) => {
                ctx.fillText( part , xpos - ctx.measureText(part).width / 2 , ypos );
                ypos = ypos + LINE_HEIGHT + 2;
            });            
            cnt = cnt +  1;
        });
    }

    private plotPoints(canvas: any) {
        const ctx = canvas.getContext('2d');
        let cnt = 0;
        this.dataPointsPos = [];
        this.props.data.forEach( (plotpt: any) => {
            let range = this.getRange( plotpt );
            let xpos = XPOINT_DISP + cnt * XPOINT_DIST;
            let ypos =  ( (range.index - 1) * (this.props.height * YRANGE_PERCENT) ) + 
                        (this.props.height * YRANGE_PERCENT) * (range.percentage);
            
            // draw circle
            this.drawCircle(ctx, xpos, ypos, 6, '#eeeeee');
            this.drawCircle(ctx, xpos, ypos, 4, '#0B68F3');

            this.dataPointsPos.push( { p1: { x: xpos - 6, y: ypos - 6 }, p2: { x: xpos +  6 , y: ypos + 6 } } );
            cnt++;
        });
    }

    private  drawBaseLine(canvas: any) {
        const ctx = canvas.getContext('2d');
        let range = this.getRange(this.props.baselineScore);
        let ypos =  ( (range.index - 1) * (this.props.height * YRANGE_PERCENT) ) + 
                        (this.props.height * YRANGE_PERCENT) * (range.percentage);
        // draw line
        ctx.fillStyle = '#0B68F3';
        ctx.fillRect(0, ypos, canvas.width, 4);
    }

    private drawCircle( ctx: any, xpos: number, ypos: number, circleRadius: number, color: string ) {
        let oldFillStyle = ctx.fillStyle;
        ctx.fillStyle = color;
        ctx.beginPath();
        ctx.arc( xpos, ypos, circleRadius , 0, 2 * Math.PI, false);
        ctx.fill();
        ctx.strokeStyle = ctx.fillStyle;
        ctx.stroke();
        ctx.fillStyle = oldFillStyle;
    }
    private getRange( point: any ) {
        let previousStopPoint = 0;
        let currentStopPoint = -1;
        let index = this.props.yRangeValues.length;
        for ( let i = 0; i < this.props.yRangeValues.length; i++ ) {
            if ( point < this.props.yRangeValues[i] ) {
                currentStopPoint = this.props.yRangeValues[i];
                index = i ;
                break;
            }
            previousStopPoint = this.props.yRangeValues[i];
        }

        let width = currentStopPoint === -1 ? 
                    this.props.yMax - previousStopPoint : currentStopPoint - previousStopPoint ;
        return { percentage: point > this.props.yMax ? 1 : ( (point - previousStopPoint) / width), index };
    }

    private createGradient(canvas: any) {
        const ctx = canvas.getContext('2d');
        var grd = ctx.createLinearGradient(0, this.props.height * 0.9, 0, 0);
        
        grd.addColorStop(0, '#e13331');
        grd.addColorStop(0.5, '#e69511');
        grd.addColorStop(1, '#10fa7c');

        ctx.fillStyle = grd;
        ctx.fillRect(0 , 0, canvas.width, canvas.height * 0.9);

        ctx.fillStyle = '#222222';
        ctx.fillRect(0 , canvas.height * 0.9, canvas.width, canvas.height * 0.1);
    }
}


// WEBPACK FOOTER //
// ./src/components/common/CustomChart.tsx